export default {
  clip: 'rect(1px, 1px, 1px, 1px)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute !important',
  whiteSpace: 'nowrap',
  width: 1,
};
